module["exports"] = [
  "s Väg",
  "s Gata"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/address/common_street_suffix.js
// module id = 1732
// module chunks = 1